import { BillingGridDatasource } from '@/modules/billing-module/components/grid/config/datasources/billing-grid.datasource'
import { AppliedBillableConceptResponse } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import {
    BillingAppliedBillableConceptCategory,
    billingAppliedBillableConceptService
} from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.service'
import { CommonFilterModel, CommonParams, ExportCommonParams } from '@/api/resources/common/shared/models/common.models'
import { AgColumnDefinition, IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { billingGridConceptsColumnDefs } from '@/modules/billing-module/components/grid/config/column-defs/billing-grid-concepts.column-defs'
import {
    BillingSearcherMode,
    BillingSearcherParams,
    BillingSearcherCaseMode
} from '@/modules/billing-module/components/searcher/billing-searcher.model'
import { StrictNullable } from '@/shared/types/app.types'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { GridUtils } from '@/shared/util/grid-utils'
import { ReportGridRequest } from '@/api/services/common.dto'
import { AxiosResponse } from 'axios'

export class BillingGridConceptsDatasource extends BillingGridDatasource<AppliedBillableConceptResponse> {
    private readonly _category: BillingAppliedBillableConceptCategory | undefined

    constructor(laboratoryId: number, mode?: BillingAppliedBillableConceptCategory) {
        super(laboratoryId)
        this._category = mode
    }

    public getColumnDefs(): AgColumnDefinition[] {
        return billingGridConceptsColumnDefs()
    }
    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<AppliedBillableConceptResponse>> {
        return billingAppliedBillableConceptService.paginator(filterModel, params, this.laboratoryId, this._category)
    }

    public exporter(request: ReportGridRequest, params: ExportCommonParams): Promise<AxiosResponse<Blob>> {
        return billingAppliedBillableConceptService.export(this.laboratoryId, request, params, this._category)
    }

    public getSearcherModes(): BillingSearcherMode[] {
        return [
            BillingSearcherMode.PATIENT,
            BillingSearcherMode.CASE
        ]
    }
    public searcher(searcherParams: BillingSearcherParams): Promise<StrictNullable<IResponseAgGrid<AppliedBillableConceptResponse>>> {
        const { mode, caseScope, patientsIds, identifierSearch } = searcherParams

        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const filterModel: CommonFilterModel = {}
        if (mode === BillingSearcherMode.PATIENT && patientsIds) {
            filterModel['caseStudy.patient.id'] = GridUtils.getSetFilterModel(patientsIds.map(patientId => `${patientId}`))
        } else if (mode === BillingSearcherMode.CASE) {
            let caseFieldName: string | undefined
            if (caseScope === BillingSearcherCaseMode.IDENTIFIER) {
                caseFieldName = 'caseStudy.casCasenumber'
            } else if (caseScope === BillingSearcherCaseMode.INSURANCE_DOCUMENT) {
                caseFieldName = 'caseStudy.referralNumber'
            } else if (caseScope === BillingSearcherCaseMode.INSURANCE_POLICY) {
                caseFieldName = 'caseStudy.insuranceNumber'
            }
            if (caseFieldName) {
                filterModel[caseFieldName] = GridUtils.getTextFilterModel('contains', identifierSearch)
            }
        }
        return this.fetchData(filterModel, params)
    }
}
